import React, { Component } from "react";
import { getUserNameForAvatar } from "Utils";

import _ from "i18n";
import { SvgIcon } from "../Common/Icons";
import styles from "./Authorizations.local.scss";
import classnames from "classnames";
import { TTP_API_URL } from "Config";

export default class User extends Component {
  render() {
    const { user, selectedUsers } = this.props;
    const {
      id,
      firstName,
      lastName,
      avatar,
      avatarUrl,
      role,
      dataAuthorization
    } = user;

    const isSelected = selectedUsers.some(({ id }) => id === user.id);

    let avatarDiv = null;
    const checkDiv = (
      <span
        id={`check-${id}`}
        className={classnames(
          styles.user_check,
          "icon",
          isSelected ? styles.active : ""
        )}
      >
        {<SvgIcon icon={"CheckAuthorisationIcon"} />}
      </span>
    );

    if (avatarUrl !== undefined) {
      avatarDiv = (
        <div
          id={`avatar-${id}`}
          className={classnames(
            styles.user_avatar,
            "employee",
            isSelected ? styles.selected : ""
          )}
          onClick={() => this.props.handleSelectedUsers(user)}
          style={{ backgroundImage: `url(${avatarUrl})` }}
        >
          {checkDiv}
        </div>
      );
    } else if (avatar) {
      avatarDiv = (
        <div
          id={`avatar-${id}`}
          className={classnames(
            styles.user_avatar,
            "employee",
            isSelected ? styles.selected : ""
          )}
          onClick={() => this.props.handleSelectedUsers(user)}
          style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
        >
          {checkDiv}
        </div>
      );
    } else {
      avatarDiv = (
        <div
          id={`avatar-${id}`}
          className={classnames(
            styles.user_avatar,
            "empty-avatar",
            "employee",
            isSelected ? styles.selected : ""
          )}
          onClick={() => this.props.handleSelectedUsers(user)}
        >
          <span className="empty-avatar__initials">
            {getUserNameForAvatar(firstName, lastName)}
          </span>
          {checkDiv}
        </div>
      );
    }

    let signatureDiv = [];
    signatureDiv.push(<h3 key="h3">{firstName + " " + lastName}</h3>);
    signatureDiv.push(
      <h4 key="h4">
        <span>{role && role.id !== undefined ? _(role.type) : "____"}</span>
      </h4>
    );
    signatureDiv.push(
      <h5 key="h5">
        {dataAuthorization && dataAuthorization.role !== undefined
          ? _(dataAuthorization.role)
          : "____"}
      </h5>
    );

    return (
      <div
        className={classnames(styles.user, "column small-12 medium-6 large-4")}
      >
        <div className={styles.user_container} />
        {avatarDiv}
        <div className={styles.user_header}>{signatureDiv}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authorizations/User.js